import { timestampDate } from '@bufbuild/protobuf/wkt'
import { useMemo } from 'react'

import { useGetCompanyActivityLog } from '@/api/company.hook'
import {
  CompanyActivityLogItem,
  OrgCompanyEngagementChangeLog,
  OrgCompanyEngagementChangeType,
} from '@/gen/inventory/v1/company_service_pb'

import { LEMA_USER_ID } from '@/const/contact'

export const useLastEngagementIrqChange = (companyId: string, engagementId: string) => {
  const { data: activityLogData, isLoading } = useGetCompanyActivityLog(companyId)

  const lastIRQChange = useMemo(() => {
    const irqLogs = activityLogData?.filter(
      (item) =>
        isEngagementIrqUpdate(item) &&
        item.activityLogItem.value.orgCompanyEngagementId === engagementId,
    )

    const sortedIrqLogs = irqLogs?.sort(
      (a, b) =>
        (b?.time ? timestampDate(b.time).getTime() : 0) -
        (a?.time ? timestampDate(a.time).getTime() : 0),
    )

    const firstNonLemaLog = sortedIrqLogs?.find((log) => log.userId)
    const firstLog = sortedIrqLogs?.[0]
    const source = firstNonLemaLog ?? firstLog

    return {
      userId: firstNonLemaLog?.userId || firstLog?.userId || LEMA_USER_ID,
      time: firstNonLemaLog?.time || firstLog?.time,
      integrationSource: source?.integrationSource,
    }
  }, [activityLogData, engagementId])

  return { lastIRQChange, isLoading }
}

export const isEngagementIrqUpdate = (
  item: CompanyActivityLogItem,
): item is CompanyActivityLogItem & {
  activityLogItem: { case: 'orgCompanyEngagementChangeLog'; value: OrgCompanyEngagementChangeLog }
} => {
  return (
    item.activityLogItem.case === 'orgCompanyEngagementChangeLog' &&
    (item.activityLogItem.value.changeType === OrgCompanyEngagementChangeType.IRQ_UPDATE ||
      !item.userId)
  )
}
